import React, {
  useContext, useEffect, useState, useRef,
} from 'react';
import PropTypes from 'prop-types';
import { LayoutContext } from '@/components/Layout';
import useStyle from './style';
import cx from '@/utils/cx';

const LayoutBar = ({
  children,
  type,
  className,
  position,
  tag,
  shadow,
  ...rest
}) => {
  const { scrollTop } = useContext(LayoutContext) || 0;
  const [scrolled, setScrolled] = useState(false);
  const classes = useStyle({ position });
  const offsetProp = `margin${position[0].toUpperCase()}${position.substr(1)}`;
  const Component = tag;

  const [offset, setOffset] = useState(0);
  const el = useRef();

  useEffect(() => {
    if (scrollTop > 0) {
      setScrolled(true);
      return;
    }
    setScrolled(false);
  }, [scrollTop]);

  useEffect(() => {
    if (type === 'overlay') {
      setOffset(`${-1 * el.current.offsetHeight}px`);
    } else {
      setOffset(0);
    }
  }, [type]);
  return (
    <>
      <Component
        ref={el}
        style={{ [offsetProp]: offset }}
        className={cx(classes.layoutBar, type, position, className, (scrolled && type === 'fixed') && 'shadow')}
        {...rest}
      >
        {children}
      </Component>
    </>
  );
};

LayoutBar.propTypes = {
  type: PropTypes.oneOf(['static', 'fixed', 'overlay', 'device-fixed']),
  position: PropTypes.oneOf(['top', 'bottom']).isRequired,
  tag: PropTypes.string,
};

LayoutBar.defaultProps = {
  type: 'overlay',
  tag: 'div',
};

export default LayoutBar;
